import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Warning from "../components/Warning";
import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

const SECTIONS = [
  {
    role: "I'm an employer",
    desc: "I want to reach out about a potential job offer.",
    email: "jrfpk4@umkc.edu",
    phone: "+1(816)447-6405",
  },
  {
    role: "Media Code Inquiries",
    desc: "I have questions on content I may be a part of.",
    email: "jack@csfrederick.com",
    phone: "+1(816)447-6405",
  },
  {
    role: "Bug Reports",
    desc: "I found a bug with one of your services.",
    email: "jack@csfrederick.com",
    phone: "+1(816)447-6405",
  },
];

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      enterTxt: "Enter",
      exForm: "",
      index: 2,
      sentences: ["######", "X##XXXX", "GXX##X", "WEB##X"],
    };
  }
  static defaultProps = {
    updateableText: "Submit",
    classButton: "",
  };

  async handleClick() {
    var data;
    var type;
    try {
      const response = await fetch(
        "https://api.csfrederick.com/data/" + this.state.inputValue,
        { mode: "cors" }
      );
      data = await response.json();
      type = 1;
    } catch (err) {
      try {
        const response = await fetch(
          "https://api.csfrederick.com/uuid/" + this.state.inputValue,
          { mode: "cors" }
        );
        data = await response.json();
        type = 2;
      } catch (err) {
        data = "ID doesn't exist!";
      }
    }
    if (data === "ID doesn't exist!") {
      this.setState({ enterTxt: "Try again", exForm: "Fail" });
    } else {
      if (type === 1) {
        window.location.href = "/photo?id=" + this.state.inputValue;
      } else {
        window.location.href = "/uuid?uuid=" + this.state.inputValue;
      }
    }
  }

  render() {
    return (
      <div className="App" style={{ margin: "-8px" }}>

        <style>{`
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(22px); }
            to   { opacity: 1; transform: translateY(0); }
          }
          @keyframes fadeIn {
            from { opacity: 0; }
            to   { opacity: 1; }
          }

          .contact-enter-title {
            animation: fadeUp 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
            animation-delay: 0.05s;
          }
          .contact-enter-subtitle {
            animation: fadeUp 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
            animation-delay: 0.18s;
          }
          .contact-enter-section {
            animation: fadeUp 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
          }

          /* Contact cards */
          .contact-card {
            position: relative;
            border-radius: 14px;
            padding: 20px 24px;
            margin-bottom: 16px;
            background: rgba(255,255,255,0.03);
            border: 1px solid rgba(160,110,255,0.15);
            transition: border-color 0.25s ease,
                        box-shadow 0.25s ease,
                        transform 0.22s cubic-bezier(0.22, 1, 0.36, 1);
          }
          .contact-card:hover {
            border-color: rgba(160,110,255,0.4);
            box-shadow: 0 0 28px 4px rgba(150,100,255,0.12),
                        0 4px 24px rgba(0,0,0,0.15);
            transform: translateY(-2px);
          }
          /* subtle glow bloom behind each card */
          .contact-card::before {
            content: '';
            position: absolute;
            inset: -12px;
            border-radius: 20px;
            background: radial-gradient(ellipse at 50% 50%, rgba(150,100,255,0.1) 0%, transparent 70%);
            filter: blur(12px);
            z-index: -1;
            opacity: 0;
            transition: opacity 0.25s ease;
            pointer-events: none;
          }
          .contact-card:hover::before {
            opacity: 1;
          }
        `}</style>

        <HelmetProvider>
          <Helmet>
            <title>Get in Touch</title>
            <meta
              name="Get in Touch; Jack Frederick"
              content="Contact Information"
              description="Contact Information"
              author="Jack Frederick"
            />
          </Helmet>
        </HelmetProvider>

        <Warning />
        <Navbar />

        <header className="Home">
          <br />
          <div className="screenBox Minsize">
            <p className="Homethick contact-enter-title">Contact</p>
            <p className="Homemid contact-enter-subtitle">Feel free to reach out!</p>
            <br />

            {SECTIONS.map(({ role, desc, email, phone }, i) => (
              <div
                key={i}
                className="contact-card contact-enter-section"
                style={{ animationDelay: `${0.3 + i * 0.12}s` }}
              >
                <p className="Homemid bold clingTop" style={{ marginBottom: "6px" }}>{role}</p>
                <p className="Homesmall clingTop clingBottom">{desc}</p>
                <p className="Homesmall clingBottom">
                  <a className="contact-detail" href={`mailto:${email}`}>{email}</a>
                  <br />
                  <a className="contact-detail" href={`tel:${phone.replace(/[^+\d]/g, "")}`}>{phone}</a>
                </p>
              </div>
            ))}

            <br /><br /><br />
            <div className="photoSpacer" />
            <div className="photoSpacer" />
          </div>
        </header>

        <Footer />
      </div>
    );
  }

  updateInputValue(evt) {
    const val = evt.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    this.setState({ inputValue: val });
  }
}

export default App;